<form [id]="formId" [formGroup]="formGroup" [attr.aria-describedby]="ariaDescribedBy">
	<div
		class="dynamic-form--row"
		[ngClass]="{
			'dynamic-row-layout--row': layoutXs === 'row',
			'dynamic-row-layout--column': layoutXs === 'column'
		}"
		*ngFor="let row of controls"
	>
		<div
			*ngFor="let control of row; let rowIndex = index"
			class="dynamic-form--column"
			[ngClass]="control.cssClass"
			[ngStyle]="{
				'max-width':
					currentScreenSize === 'Medium' || currentScreenSize === 'Large' || currentScreenSize === 'XLarge'
						? (control.size || 100 / row.length) + '%'
						: '100%'
			}"
		>
			<!-- DATE COLLECTION -->
			<ng-container *ngIf="control.controlType === 'dateCollection'; else inputControl">
				<ahp-date-collection
					[minAge]="control.minAge"
					[maxAge]="control.maxAge"
					[maxDate]="control.maxDate"
					[minDate]="control.minDate"
					[control]="control"
					[value]="control.value"
					[creditCardExpiration]="control.creditCardExpiration"
					[use]="control.dateCollectionUse"
					(dateChanged)="formGroup.controls[control.key].setValue($event)"
					[formSubmitted]="formSubmitted"
					[attr.data-cy]="'dynamic-form__date--' + control.key"
				></ahp-date-collection>
				<input type="hidden" [name]="control.key" [value]="control.value" />
			</ng-container>

			<!-- TEXT AREA -->
			<ng-template #inputControl>
				<div
					*ngIf="control.controlType === 'textarea'"
					[ngClass]="{
						'dynamic-form--hide': control.hideOnDisabled && formGroup.controls[control.key].disabled
					}"
				>
					<gap-input
						gap-color="secondary"
						[attr.disabled]="control.disabled"
						[attr.gap-error]="
							(formSubmitted || formGroup.controls[control.key].touched) &&
							formGroup.controls[control.key].errors
								? true
								: false
						"
					>
						{{ control.label | locale }}
						<textarea
							#message
							[formControlName]="control.key"
							[attr.name]="control.key"
							[attr.data-cy]="'dynamic-form__textarea--' + control.key"
							[attr.aria-describedby]="control.key + '-error'"
							#textInput
							placeholder="{{ control.placeholder | locale }}"
						></textarea>
						<div
							[id]="control.key + '-error'"
							slot="helper"
							class="gap-input__helper-text"
							*ngIf="formGroup.controls[control.key].errors"
						>
							{{ getErrors(formGroup.controls[control.key].errors) }}
						</div>
						<div
							slot="helper"
							class="gap-input__helper-text"
							*ngIf="control.hint && !formGroup.controls[control.key].errors"
						>
							{{ control.hint | locale }}
						</div>
						<div slot="helper" class="gap-input__helper-count" *ngIf="displayMaxLength(control)">
							0 / {{ control.maxLength }}
						</div>
					</gap-input>
				</div>

				<!-- SELECT DROPDOWN -->
				<div
					*ngIf="control.controlType === 'select'"
					[ngClass]="{
						'dynamic-form--hide': control.hideOnDisabled && formGroup.controls[control.key].disabled
					}"
				>
					<gap-select
						gap-color="secondary"
						class="gap-menu__anchor"
						class="gap-display--block"
						[attr.gap-error]="
							(formSubmitted || formGroup.controls[control.key].touched) &&
							formGroup.controls[control.key].errors
								? true
								: false
						"
						[attr.aria-controls]="control.key"
						[formControlName]="control.key"
						ngDefaultControl
						[attr.aria-describedby]="control.key + '-error'"
						[attr.name]="control.key"
						[attr.disabled]="control.disabled"
						[attr.data-cy]="'dynamic-form__select--' + control.key"
					>
						<span slot="label"> {{ control.label | locale }} </span>
						<gap-menu>
							<gap-menu-item data-value=""></gap-menu-item>
							<ng-container *ngIf="control.asyncOptions; else selectOptions">
								<gap-menu-item
									*ngFor="let opt of control.asyncOptions | async"
									[attr.data-value]="opt.value"
									[ngClass]="{
										'mdc-list-item--selected': formGroup.controls[control.key].value === opt.value
									}"
								>
									{{ opt.label }}
								</gap-menu-item>
							</ng-container>
							<ng-template #selectOptions>
								<gap-menu-item
									*ngFor="let opt of control.options"
									[attr.data-value]="opt.value"
									[attr.data-cy]="'dynamic-form__select-option--' + opt.value?.replace(' ', '')"
									[ngClass]="{
										'mdc-list-item--selected': formGroup.controls[control.key].value === opt.value
									}"
								>
									{{ opt.value }}
								</gap-menu-item>
							</ng-template>
						</gap-menu>
						<div
							slot="helper"
							class="gap-helper-line__text"
							*ngIf="
								(formSubmitted || formGroup.controls[control.key].touched) &&
									formGroup.controls[control.key].errors;
								else selectHint
							"
						>
							{{ getErrors(formGroup.controls[control.key].errors) }}
						</div>
						<ng-template #selectHint>
							<div slot="helper" class="gap-helper-line__text" *ngIf="control.hint">
								{{ control.hint | locale }}
							</div>
						</ng-template>
					</gap-select>
				</div>

				<!-- STATE DROPDOWN/INPUT -->
				<ng-container *ngIf="control.controlType === 'state' && countries.length">
					<ng-container
						*ngIf="
							!!regions && regions[formGroup.controls[control.countryKey]?.value];
							else stateProvinceInput
						"
					>
						<div
							[ngClass]="{
								'dynamic-form--hide': control.hideOnDisabled && formGroup.controls[control.key].disabled
							}"
							class="gap-menu__anchor"
						>
							<gap-select
								gap-color="secondary"
								class="gap-display--block"
								[attr.gap-error]="
									(formSubmitted || formGroup.controls[control.key].touched) &&
									formGroup.controls[control.key].errors
										? true
										: false
								"
								[attr.aria-controls]="control.key"
								[formControlName]="control.key"
								ngDefaultControl
								[attr.aria-describedby]="control.key + '-error'"
								[attr.name]="control.key"
								[attr.disabled]="control.disabled"
								[attr.data-cy]="'dynamic-form__select--' + control.key"
							>
								<span slot="label">
									{{
										getStateProvinceLabel(
											formGroup.controls[control.countryKey]?.value,
											control.label
										) | locale
									}}
								</span>
								<gap-menu>
									<gap-menu-item data-value=""></gap-menu-item>
									<gap-menu-item
										*ngFor="let opt of regions[formGroup.controls[control.countryKey]?.value]"
										[attr.data-value]="opt.value"
										[ngClass]="{
											'mdc-list-item--selected':
												formGroup.controls[control.key].value === opt.value
										}"
										[attr.gap-label]="getRegionLabel(opt)"
										[attr.data-cy]="'dynamic-form__select-option--' + opt.value?.replace(' ', '')"
									>
										{{ getRegionLabel(opt) }}
									</gap-menu-item>
								</gap-menu>
								<div
									slot="helper"
									class="gap-helper-line__text"
									*ngIf="
										(formSubmitted || formGroup.controls[control.key].touched) &&
											formGroup.controls[control.key].errors;
										else selectHint
									"
								>
									{{ getErrors(formGroup.controls[control.key].errors) }}
								</div>
								<ng-template #selectHint>
									<div slot="helper" class="gap-helper-line__text" *ngIf="control.hint">
										{{ control.hint | locale }}
									</div>
								</ng-template>
							</gap-select>
						</div>
					</ng-container>
					<ng-template #stateProvinceInput>
						<gap-form-control
							[ngClass]="{
								'dynamic-form--hide': control.hideOnDisabled && formGroup.controls[control.key].disabled
							}"
						>
							<gap-input
								gap-color="secondary"
								class="gap-display--block"
								[attr.gap-error]="
									(formSubmitted || formGroup.controls[control.key].touched) &&
									formGroup.controls[control.key].errors
										? true
										: false
								"
								[attr.disabled]="control.disabled"
							>
								<gap-input-label [hidden]="control.hideLabel">{{
									getStateProvinceLabel(formGroup.controls[control.countryKey]?.value, control.label)
										| locale
								}}</gap-input-label>
								<input
									#textInput
									type="text"
									slot="input"
									[id]="control.key"
									[formControlName]="control.key"
									[attr.name]="control.key"
									[attr.maxLength]="control.maxLength"
									[attr.autocomplete]="control.autocomplete"
									[placeholder]="control.placeholder | locale"
									[attr.aria-describedby]="control.key + '-error'"
									[attr.data-cy]="'dynamic-form__input--' + control.key"
								/>
								<div
									[id]="control.key + '-error'"
									slot="helper"
									class="gap-input__helper-text"
									*ngIf="
										(formSubmitted || formGroup.controls[control.key].touched) &&
											formGroup.controls[control.key].errors;
										else stateProvinceHint
									"
								>
									{{ getErrors(formGroup.controls[control.key].errors) }}
								</div>
								<ng-template #stateProvinceHint>
									<div slot="helper" class="gap-input__helper-text" *ngIf="control.hint">
										{{ control.hint | locale }}
									</div>
								</ng-template>
								<div slot="helper" class="gap-input__helper-count" *ngIf="displayMaxLength(control)">
									0 / {{ control.maxLength }}
								</div>
							</gap-input>
						</gap-form-control>
					</ng-template>
				</ng-container>

				<!-- TEXT INPUT -->
				<div
					*ngIf="control.controlType === 'text'"
					[ngClass]="{
						'dynamic-form--hide': control.hideOnDisabled && formGroup.controls[control.key].disabled
					}"
				>
					<gap-input
						gap-color="secondary"
						class="gap-display--block"
						[attr.gap-error]="
							(formSubmitted || formGroup.controls[control.key].touched) &&
							formGroup.controls[control.key].errors
								? true
								: false
						"
						[attr.disabled]="control.disabled"
					>
						{{ control.label | locale }}
						<input
							[id]="control.key"
							[formControlName]="control.key"
							[attr.name]="control.key"
							[attr.type]="control.type"
							[attr.maxLength]="control.maxLength"
							[attr.pattern]="control.type === 'number' ? '[0-9]*' : null"
							#textInput
							[attr.autocomplete]="control.autocomplete"
							[placeholder]="control.placeholder | locale"
							[attr.aria-label]="control.label | locale"
							[attr.aria-describedby]="control.key + '-error'"
							[attr.data-cy]="'dynamic-form__input--' + control.key"
							(ahpOnEnter)="handleEnterPress(control)"
							(keydown.space)="handleKeyDownSpacePress(control, $event)"
							slot="input"
						/>
						<div
							[id]="control.key + '-error'"
							slot="helper"
							class="gap-input__helper-text"
							*ngIf="
								(formSubmitted || formGroup.controls[control.key].touched) &&
									formGroup.controls[control.key].errors;
								else textHint
							"
						>
							{{ getErrors(formGroup.controls[control.key].errors) }}
						</div>
						<ng-template #textHint>
							<div slot="helper" class="gap-input__helper-text" *ngIf="control.hint">
								{{ control.hint | locale }}
							</div>
						</ng-template>
						<div slot="helper" class="gap-input__helper-count" *ngIf="displayMaxLength(control)">
							0 / {{ control.maxLength }}
						</div>
					</gap-input>
				</div>

				<!-- PHONE INPUT -->
				<div *ngIf="control.controlType === 'phone'" class="gap-menu__anchor">
					<gap-input
						gap-color="secondary"
						class="phone-number--enhanced gap-display--block"
						[attr.gap-error]="
							(formSubmitted || formGroup.controls[control.key].touched) &&
							formGroup.controls[control.key].errors
								? true
								: false
						"
						[attr.disabled]="control.disabled"
						[style.z-index]="row.length - rowIndex"
					>
						{{ control.label | locale }}
						<input
							slot="input"
							type="text"
							pattern="[0-9]+"
							[id]="control.key"
							[formControlName]="control.key"
							[attr.name]="control.key"
							[attr.maxLength]="control.maxLength"
							#textInput
							[placeholder]="control.placeholder | locale"
							[attr.autocomplete]="control.autocomplete"
							[attr.aria-describedby]="control.key + '-error'"
							[attr.data-cy]="'dynamic-form__input--' + control.key"
							inputmode="numeric"
							(ahpOnEnter)="handleEnterPress(control)"
						/>
						<div slot="prefix-icon" class="gap-menu__anchor" *ngIf="useEnhancedPhoneNumber">
							<span (click)="toggleDropdown(true, control.key)" class="enhanced-phone-prefix">
								<gap-flag-icon
									*ngIf="showFlag"
									[attr.gap-icon]="getFlagCodeChosen(control.key)"
								></gap-flag-icon>
								+{{ getCountryCodeChosen(control.key) }}
								<gap-iconography
									gap-icon="small-arrow-down-solid"
									[ngClass]="false ? 'icon-opened' : 'icon-closed'"
								></gap-iconography>
							</span>
							<gap-menu
								slot="prefix-icon"
								id="prefix-menu"
								[attr.gap-open]="toggleObj[control.key].open ? 'true' : 'false'"
								gap-position="1"
								[attr.data-cy]="'dynamic-form__menu--' + control.key"
							>
								<gap-menu-item
									*ngFor="let country of countries"
									[attr.data-value]="country"
									[ngClass]="{
										'mdc-list-item--selected':
											formGroup.controls[control.key + 'CountryCode']?.value === country.code
									}"
									[attr.data-cy]="'dynamic-form__menu-item--' + country.countryCode"
									(click)="selectedCountry(control.key, country); toggleDropdown(false, control.key)"
								>
									<div class="dynamic-form--phone-country">
										<gap-flag-icon
											*ngIf="showFlag"
											[attr.gap-icon]="country.code | lowercase"
										></gap-flag-icon>
										<span>{{ '+' + country.countryCode }} {{ country.name }}</span>
									</div>
								</gap-menu-item>
							</gap-menu>
						</div>
						<div
							[id]="control.key + '-error'"
							slot="helper"
							class="gap-input__helper-text"
							gap-error="true"
							*ngIf="
								(formSubmitted || formGroup.controls[control.key].touched) &&
									formGroup.controls[control.key].errors;
								else phoneHint
							"
						>
							{{ getErrors(formGroup.controls[control.key].errors) }}
						</div>
						<ng-template #phoneHint>
							<div slot="helper" class="gap-input__helper-text" *ngIf="control.hint">
								{{ control.hint | locale }}
							</div>
						</ng-template>
						<div slot="helper" class="gap-input__helper-count" *ngIf="displayMaxLength(control)">
							0 / {{ control.maxLength }}
						</div>
					</gap-input>
				</div>

				<!-- CHECKBOX INPUT -->
				<gap-checkbox *ngIf="control.controlType === 'checkbox'">
					<input
						slot="input"
						[attr.data-cy]="'dynamic-form__menu--' + control.key"
						type="checkbox"
						[formControlName]="control.key"
					/>
					{{ control.label | locale }}
				</gap-checkbox>
			</ng-template>
		</div>
	</div>
</form>
